
<div class="d-flex lobby3 desktop" :class="jel_getClassObject(content)">
  <template v-if="isVisible && produit">
    <CarteImageInfo
      class="table lobby-table-block table-details-loaded"
      :class="produit.gameTypeUnified"
      :data-game="produit.gameTypeUnified"
      :content="getContentCarteImageInfo()"
      :afficherInfoSecondaire="true"
    >
      <template #image>
        <b-img
          v-if="produit.videoSnapshotBG"
          :src="produit.videoSnapshotBG"
          :alt="content.altImage"
          class="image-ced"
        >
        </b-img>
        <div v-else class="BIDON-TEMP">TODO: Image par défaut<br />(table fermée)</div>
      </template>

      <template #infoSecondaire>
        <!-- ref="conteneurLotProgressif" -->
        <CarteInfoSecondaireCED
          :produit="produit"
          class="lobby-table-game-specific-data"
        ></CarteInfoSecondaireCED>
      </template>
      <template #infoPrimaire>
        <CarteInfoPrimaireProduit
          :produit="produitCarteInfoPrimaireProduit"
          :cacherSurTitreCategorie="content.cacherSurTitreCategorie === 'true'"
        ></CarteInfoPrimaireProduit>
      </template>
    </CarteImageInfo>
  </template>
  <div
    v-else
    v-observe-visibility="{
      callback: visibilityChanged,
      once: true,
    }"
    class="chargement w-100 h-100"
  >
    <Carte :content="content" class="w-100">
      <b-skeleton-img no-aspect height="240px"></b-skeleton-img>

      <span v-if="produit" class="text-truncate"
        >{{ mixinProduitCasino_getTitre(false) }}...</span
      >

      <div class="row">
        <div class="col-6">
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
          <b-skeleton width="85%"></b-skeleton>
        </div>
        <div class="col-6">
          <b-skeleton type="button"></b-skeleton>
        </div>
      </div>
    </Carte>
  </div>
</div>
